import { AccountingBalancePostingsService_balancePostingsServiceGetQuery } from '@festina/life-general-types/life/hooks/AccountingBalancePostingsService_balancePostingsServiceGetQuery'

export const useLazyFetchBalancePostings =
  AccountingBalancePostingsService_balancePostingsServiceGetQuery.useLazyQuery
